import React from "react";

// Small square icon mark — used in tight spots (collapsed sidebar, "Managed by" pills, avatars).
// The full ISOQuest wordmark PNG would be illegible below ~80px wide, so we render a compact
// brand-gradient tile with a stylized "iQ" glyph that echoes the logo's purple/blue "Q".
export const LogoMark = ({ size = 36 }) => (
  <div
    data-testid="brand-logo-mark"
    className="relative rounded-2xl brand-gradient shadow-lg shadow-indigo-500/30 flex items-center justify-center overflow-hidden"
    style={{ width: size, height: size }}
    aria-label="ISOQuest"
  >
    <span
      className="font-display font-black text-white leading-none tracking-tight select-none"
      style={{ fontSize: size * 0.5 }}
    >
      iQ
    </span>
    <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-emerald-400 ring-2 ring-white dark:ring-slate-900" />
  </div>
);

// Full logo (wordmark). Rendered from the uploaded ISOQuest PNG in TopNav and SideNav headers.
const Logo = ({ compact = false, height = 44 }) => (
  <div className="flex items-center" data-testid="top-navbar-logo">
    <img
      src="/isoquest-logo.png"
      alt="ISOQuest — Management Consultants"
      style={{ height }}
      className="w-auto object-contain select-none dark:brightness-110"
      draggable={false}
    />
    {compact && <span className="sr-only">ISOQuest Management Portal</span>}
  </div>
);

export default Logo;
